import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {FormBuilder, Validators} from "@angular/forms";

export interface DialogData_AbortAssessmentDialogInput extends MatDialogDataBaseInput {}

interface DialogData_AbortAssessmentDialogOutput extends MatDialogDataBaseOutput {
	reason: string;
}

@Component({
	selector: "sim-abort-assessment-dialog",
	templateUrl: "./abort-assessment-dialog.component.html",
	styleUrls: ["./abort-assessment-dialog.component.scss"],
	standalone: false,
})
export class AbortAssessmentDialogComponent extends BasicMaterialDialog<
	AbortAssessmentDialogComponent,
	DialogData_AbortAssessmentDialogInput,
	DialogData_AbortAssessmentDialogOutput
> {
	abortAssessmentForm = this._fb.group({
		reason: ["", [Validators.required, Validators.minLength(30)]],
	});

	constructor(
		_injector: Injector,
		private _fb: FormBuilder,
	) {
		super(_injector);
	}
}
